import { Injectable } from "@angular/core";
import { CategoryDirectory } from "app/components/class/directory/category";
import { Week } from "app/components/class/category/week";
import { Stats } from "app/components/class/stats/stats";
import { Settings } from "app/components/class/setting";
import { TableData } from "app/components/class/table-data";
import { SingService } from "app/components/service/sing.service";
import { requestGetStats } from "app/components/class/http/req/request-get-stats";
import { requestRtbData } from "app/components/class/http/req/request-get-rtb-data";
import { requestGetCategory } from "app/components/class/http/req/request-get-category";
import { Expense } from "app/components/class/expense/expense";



@Injectable()
export class LeftMenuService {
    startEditMode: boolean = false;
    sub: any;
    weeks: Array<Week> = [];
    stats: Stats;
    ListProducts: Array<CategoryDirectory>;
    color: string = "";
    // EditMode: boolean = false;
    getParams: any;
    mediaCategories: Array<String> = [];
    blockEditMedia: boolean = false;
    closedAddProductEventListener:Function = null;
    initAddProductEventListener:Function = null;
    constructor(   private httpService: SingService,) { }
    public setSettigs(params, settings: Settings, tableData: TableData) {
        tableData.settings.month = +(Number(params['month']) + 1) || settings.month;
        tableData.settings.year = settings.year;
        tableData.settings.viewType = settings.viewType;
        tableData.settings.quarter = settings.quarter;
    }
    public setSettingLocalStorage (tableData:TableData) {
        window.localStorage.setItem('settings', JSON.stringify({
            month: tableData.settings.month,
            year: tableData.settings.year, viewType: tableData.settings.viewType,
            quarter: tableData.settings.quarter
        }));
    }
    public onInitscrollToAddProduct (element) {
        var box = element.getBoundingClientRect();
        let top = box.top + pageYOffset;
        if (((window.pageYOffset || document.documentElement.scrollTop) + document.documentElement.clientHeight) <= top) {
            window.scrollTo(0, top - document.documentElement.clientHeight + 50);
        }
    }
    public getStats (data:requestGetStats,viewType:String) {
return this.httpService.getStats(data,viewType);
    }
    public getRtbData (data:requestRtbData) {
        return this.httpService.getRtbData(data);
    }
    public getListProducts (dealerGroupId:Number) {
       return this.httpService.getListProducts(dealerGroupId);
    }
    public getСategory (data:requestGetCategory,viewType:String) {
       return this.httpService.getСategory(data,viewType);
    }
    public addExpense (data:Expense) {
        return this.httpService.addExpense(data)
    }
}


// WEBPACK FOOTER //
// ./src/app/components/rtb/left-menu/services/left-menu.service.ts